import { createCompletedItemsStoreFromState } from '../../../../features/tracking/models/CompletedItemsStore';
import { StudentStoreThunkAction } from '../../../../types/redux';
import { Guid } from '../../../model/guid';
import { Quiz } from '@ael/core-api';
import {getIsMobileSnapshot} from "../../../../hooks/useIsMobile";

export enum trackingAction {
  Tracking_AddItem = 'Tracking_AddItem',
  Tracking_ResetProgress = 'Tracking_ResetProgress',
  Tracking_Initialized = 'Tracking_Initialized',
}

export const addStartOfItem =
  (itemId: Guid): StudentStoreThunkAction =>
  (dispatch, getState) => {
    const completedItemsStore = createCompletedItemsStoreFromState(getState());
    completedItemsStore.addStartedItem(itemId);
    dispatch({ type: trackingAction.Tracking_AddItem, payload: completedItemsStore.toJS() });
  };
export const addCompletedItem =
  (itemId: Guid): StudentStoreThunkAction =>
  (dispatch, getState) => {
    const completedItemsStore = createCompletedItemsStoreFromState(getState());
    completedItemsStore.addFinishedItem(itemId);
    dispatch({ type: trackingAction.Tracking_AddItem, payload: completedItemsStore.toJS() });
  };
export const resetCompletedItems: StudentStoreThunkAction = (dispatch, getState) => {
  const completedItemsStore = createCompletedItemsStoreFromState(getState());
  completedItemsStore.reset();
  dispatch({ type: trackingAction.Tracking_ResetProgress, payload: completedItemsStore.toJS(), isMobile: getIsMobileSnapshot() });
};

export const removeQuizCompletedItems =
  (quiz: Quiz): StudentStoreThunkAction =>
  (dispatch, getState) => {
    const completedItemsStore = createCompletedItemsStoreFromState(getState());
    quiz.contentItems.forEach((itemId: string) => completedItemsStore.removeFinishedItem(itemId));
    dispatch({ type: trackingAction.Tracking_ResetProgress, payload: completedItemsStore.toJS(), isMobile: getIsMobileSnapshot() });
  };
